import { Lock } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { GoogleIcon } from "@/components/iv/AuthControls";
import { startGoogleLogin } from "@/lib/auth";

export const SignInModal = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md border-white/10 bg-[#0B1021] text-white" data-testid="signin-modal">
      <DialogHeader>
        <DialogTitle className="text-lg font-bold">Sign in to run all 20 validation criteria</DialogTitle>
        <DialogDescription className="text-sm text-slate-400">
          Your draft is saved in an encrypted vault for 120 minutes and restored automatically after sign-in.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-3">
        <button type="button" onClick={() => startGoogleLogin("?stage=2&resume=1")}
          className="flex w-full items-center justify-center gap-2 rounded-full bg-white px-4 py-3 text-sm font-semibold text-slate-900 transition-transform hover:-translate-y-0.5"
          data-testid="signin-modal-google-button">
          <GoogleIcon /> Continue with Google
        </button>
        <button type="button" disabled
          className="flex w-full cursor-not-allowed items-center justify-center gap-2 rounded-full border border-white/10 px-4 py-3 text-sm font-semibold text-slate-500"
          data-testid="signin-modal-apple-button">
           Continue with Apple — coming soon
        </button>
      </div>
      <p className="flex items-start gap-2 rounded-xl border border-emerald-400/20 bg-emerald-500/5 p-3 text-xs text-emerald-200" data-testid="signin-modal-privacy-notice">
        <Lock className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
        Your idea is encrypted and private by default. Never exposed in public URLs or used for model training.
      </p>
    </DialogContent>
  </Dialog>
);
